import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from '../../app/constants'

const collectorApplicationReview = () => ({
    "collection-agency-collector" : {
        header : "Collector application review",
        navigation : {
            next : ROUTE_PATH.ADDITIONAL_COLLECTOR_QUESTION
        }
    },
    "debt-management-agent" : {
        header : "Debt management agent application review",
        navigation : {
            next : ROUTE_PATH.ADDITIONAL_COLLECTOR_QUESTION
        }
    },
    header : "Collector application review",
    navigation : {
        next : ROUTE_PATH.ADDITIONAL_COLLECTOR_QUESTION
    }
})

const collectorApplicationReviewSlice = createSlice({
    name : "collectorApplicationReview",
    initialState : collectorApplicationReview(),
    reducers : {} 
})

export default collectorApplicationReviewSlice.reducer